module.exports = __webpack_public_path__ + "static/media/Icon_Branding_Grey.76c5f7de.svg";